module.exports = __webpack_public_path__ + "static/media/jeffreynguyen.b24715ef.jpg";